import { dingtalkBind } from '@/api/worker'
import { getNewAdmins} from '@/api/open'

export default {
    components: {},
    props: {
        showDingtalkBindForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            labelCol: {span: 5},
            wrapperCol: {span: 17},
            loading: false,
            rules: {
                mobile: [{required: true, message: '请填写手机号', trigger: 'change'}],       
            },
            admins: [],
        }
    },
    computed: {
        actType() {
            return '绑定'
        }
    },
    mounted() {
        getNewAdmins().then(res => {this.admins = res.data.list || []})
    },
    watch: {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            const data = Object.assign({}, this.model)
            console.log('data', data)
            this.loading = true
            dingtalkBind(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('设置成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showDingtalkBindForm', false)
        },
    }
}
